export abstract class BaseComponent {
    public  emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    public letterPattern = /^[a-zA-Zа-яёА-Я-\s]+$/;
    public integerPattern = /^([+-]?[1-9]\d*|0)$/;
    public floatPattern = /[+-]?([0-9]*[.])?[0-9]+/;

    //просто какой то паттерн для того что бы открылось в IE
    // public  emailPattern =  /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // public letterPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // public integerPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // public floatPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

    constructor(){
    };

     /** показать или убрать прелоадер */
     public setLoading(isLoading: boolean): void {
        if (isLoading) {
            (<any>window).$("#preloader").css('display', 'flex');
        } else {
            (<any>window).$("#preloader").hide();
        }
    }


    public  isHasError(formAndDivname : any ,func : any) {
        return !formAndDivname.$pristine && !formAndDivname.$focused && func.isValid;
    }
    public IsNotEmpty(val : any): IValidationResult {
        if(val!="" && val!=undefined && val!=null){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Поле обязательно к заполнению"
            };
        }
    }

    public NotEmpty(val : any): IValidationResult {
        if(!!(val.replace('/\s/g','')) || (!val)){
            return {
                isValid:false,
                errorText:"Поле не может быть пустым"
            }
        }
        else{
            return {
                isValid:true,
                errorText:""
            }
        }
    }

    public IsNumber(val : any): IValidationResult {
        if(!isNaN(val) && isFinite(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите число"
            };
        }
    }

    public IsNumAndInteger(val : any): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите целое число"
                };
            }
        }
        if(this.IsNumber(val) && Number.isInteger(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите целое число"
            };
        }
    }

    public IsInteger(val : any): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите целое число"
                };
            }
        }
        if( Number.isInteger(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите целое число"
            };
        }
    }
    public MaxInteger(val : any,limit:number): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите число не превыщающее " + limit
                };
            }
        }

        if( val<=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите число не превыщающее " + limit
            };
        }
    }

    public MinInteger(val : any,limit:number): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите число не меньше " + limit
                };
            }
        }
        if(val>=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите число не меньше " + limit
            };
        }
    }

    public MaxLenString(val : string,limit:number): IValidationResult {
        if(val.length<=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Максимальная длина текста " + limit
            };
        }
    }

    public MinLenString(val : string,limit:number): IValidationResult {
        if(val.length>=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Минимальная длина текста " + limit
            };
        }
    }

    public IsEmail(val : any): IValidationResult {
        var re = this.emailPattern;
        if(re.test(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Не правильный email"
            };
        }
    }



    public validateString(val : any, max=-1,min=-1): IValidationResult{
        var me = this;
        return !me.IsNotEmpty(val).isValid ? me.IsNotEmpty(val) :
        max !=1 && !me.MaxLenString(val, max).isValid ? me.MaxLenString(val, 100) :
        min !=1 && !me.MinLenString(val, min).isValid ? me.MaxLenString(val, 100) :
            {
                isValid: true,
                errorText: ""
            };
    }

    public  validateNumber(val : any,isOnlyInt = false, max=null,min=null) {
        var me = this;
        return !me.IsNotEmpty(val).isValid ? me.IsNotEmpty(val) :
        isOnlyInt && !me.IsNumAndInteger(val).isValid ? me.IsNumAndInteger(val) :
        !isOnlyInt && !me.IsNumber(val).isValid ? me.IsNumber(val) :
        max !=1 && !me.MaxInteger(val, max).isValid ? me.MaxLenString(val, 100) :
        min !=1 && !me.MaxInteger(val, min).isValid ? me.MaxLenString(val, 100) :
            {
                isValid: true,
                errorText: ""
            };
    }


    public validateStrEmail(val : any, max=-1,min=-1): IValidationResult{
        var me = this;
        return !me.IsNotEmpty(val).isValid ? me.IsNotEmpty(val) :
        max !=1 && !me.MaxLenString(val, max).isValid ? me.MaxLenString(val, 100) :
        min !=1 && !me.MinLenString(val, min).isValid ? me.MaxLenString(val, 100) :
        !me.IsEmail(val).isValid ? me.IsEmail(val) :
            {
                isValid: true,
                errorText: ""
            };
    }



    public  elemIsInvalid(elem : any) : boolean {
       return  elem.dirty && !elem.untouched && elem.invalid;
    }

  public textErrorStr(elem: any, namepattern = null) {
    if (!this.elemIsInvalid(elem))
      return "";

    if (elem.errors.maxlength)
      return "Максимальная длина поля " + elem.errors.maxlength.requiredLength + " знаков";

    if (elem.errors.minlength)
      return "Минимальная длина поля " + elem.errors.minlength.requiredLength + " знаков";

    if (elem.errors.pattern)
      return `Значение '${elem.errors.pattern.actualValue}' не соответствует шаблону`
        + (namepattern ? ` '${namepattern}'` : "");

    if (elem.errors.required)
      return "Поле обязательно для заполнения";

    if (elem.errors.minOrEquals)
      return `Значение поля должно быть строго больше ${elem.errors.minOrEquals.min}`;

    if (elem.errors.min)
      return `Значение поля не должно быть меньше ${elem.errors.min.min}`;

    if (elem.errors.max)
      return `Значение поля не должно быть больше ${elem.errors.max.max}`;

    return "";
  }

    public textErrorNum(elem : any,namepattern = null)
    {
        if(this.elemIsInvalid(elem)){
            return  elem.errors.required ? "Поле обязательно для заполнения" :
            elem.errors.max!=undefined ? ("Максимальное значение "+elem.errors.max.max.toLocaleString('fullwide', { useGrouping: true, maximumSignificantDigits:6})) :
            elem.errors.min!=undefined ? ("Минимальное значение "+elem.errors.min.min.toLocaleString('fullwide', { useGrouping: true, maximumSignificantDigits:6})) :
            elem.errors.pattern!=undefined && namepattern!=null ? ("Число должно иметь "+namepattern+" значение"):"";

        }
        return "";
    }


}

export interface IValidationResult {
    /**
     * Валидно/невалидно
     */
    isValid: boolean;
    /**
     * Текст сообщения об ошибке
     */
    errorText: string;
}



// WEBPACK FOOTER //
// ./src/app/core/base/base.component.ts